<template>
  <div class="page-container-wide">
    <div v-if="!isAdmin" class="empty-state"><p class="text-tertiary">{{ $t('admin_required') }}</p></div>
    <template v-else>
      <router-link to="/admin" class="back-link">&larr; 返回管理</router-link>
      <h2 class="mb-2">{{ postTitle }}</h2>
      <div class="stats-tabs mb-3">
        <button v-for="d in periods" :key="d.key" :class="['btn btn-sm', { 'btn-primary': days === d.val }]" @click="days = d.val; fetchStats()">{{ d.label }}</button>
      </div>
      <div v-if="loading" class="text-tertiary text-sm text-center" style="padding:40px">Loading...</div>
      <template v-else>
        <div class="stats-grid mb-3">
          <div class="stat-card"><span class="stat-num">{{ stats.total_views }}</span><span class="stat-label">总浏览</span></div>
          <div class="stat-card"><span class="stat-num">{{ stats.total_likes }}</span><span class="stat-label">总点赞</span></div>
          <div class="stat-card"><span class="stat-num">{{ stats.total_visitors }}</span><span class="stat-label">独立访客</span></div>
        </div>
        <div class="chart-box mb-3"><h3 class="mb-1">浏览趋势</h3><canvas ref="viewsChart" height="80" /></div>
        <div class="chart-box mb-3" v-if="stats.likes && stats.likes.length"><h3 class="mb-1">点赞趋势</h3><canvas ref="likesChart" height="80" /></div>
        <div v-if="stats.visitors && stats.visitors.length" class="mb-3">
          <h3 class="mb-1">访客详情 ({{ stats.visitors.length }})</h3>
          <div class="admin-list">
            <div v-for="v in stats.visitors" :key="v.ip_hash" class="admin-list-item" style="font-size:0.75rem">
              <span style="flex:1">{{ v.ip_hash }}</span>
              <span>{{ v.country }} {{ v.region }} {{ v.city }}</span>
              <span class="text-tertiary ml-1">{{ formatDate(v.created_at) }} | {{ v.count }}次</span>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { getPostStats } from '../api'
import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)

export default {
  name: 'AdminStats',
  data() {
    return {
      loading: true,
      stats: { views: [], likes: [], visitors: [], total_views: 0, total_likes: 0, total_visitors: 0 },
      days: 30,
      postTitle: '',
      periods: [
        { key: 'today', label: '今日', val: 1 },
        { key: '7d', label: '7日', val: 7 },
        { key: '30d', label: '30日', val: 30 },
        { key: '90d', label: '90日', val: 90 },
        { key: '365d', label: '365日', val: 365 },
        { key: 'all', label: '全部', val: 0 }
      ],
      chartInstances: []
    }
  },
  computed: {
    isAdmin() { return localStorage.getItem('markjy_is_admin') === 'true' },
    postId() { return this.$route.params.id }
  },
  methods: {
    formatDate(d) { if (!d) return ''; return new Date(d).toLocaleDateString() },
    fetchStats() {
      this.loading = true
      getPostStats(this.postId, this.days).then(res => {
        this.stats = res.data.data
        this.$nextTick(() => this.renderCharts())
      }).finally(() => { this.loading = false })
    },
    renderCharts() {
      this.chartInstances.forEach(c => c.destroy())
      this.chartInstances = []
      const opts = { responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } }, scales: { x: { ticks: { color: '#999' } }, y: { ticks: { color: '#999' }, beginAtZero: true } } }
      if (this.stats.views && this.stats.views.length && this.$refs.viewsChart) {
        this.chartInstances.push(new Chart(this.$refs.viewsChart, { type: 'line', data: { labels: this.stats.views.map(v => v.date), datasets: [{ data: this.stats.views.map(v => v.count), borderColor: '#888', backgroundColor: 'transparent', tension: 0.3 }] }, options: opts }))
      }
      if (this.stats.likes && this.stats.likes.length && this.$refs.likesChart) {
        this.chartInstances.push(new Chart(this.$refs.likesChart, { type: 'line', data: { labels: this.stats.likes.map(v => v.date), datasets: [{ data: this.stats.likes.map(v => v.count), borderColor: '#888', backgroundColor: 'transparent', tension: 0.3 }] }, options: opts }))
      }
    }
  },
  beforeDestroy() { this.chartInstances.forEach(c => c.destroy()) },
  mounted() {
    if (!this.isAdmin) { this.$router.replace('/'); return }
    this.fetchStats()
  }
}
</script>

<style scoped>
.back-link { display: inline-block; font-size: 0.85rem; color: var(--text-tertiary); margin-bottom: 16px; }
.back-link:hover { color: var(--text-primary); }
.stats-tabs { display: flex; gap: 4px; flex-wrap: wrap; }
.stats-grid { display: flex; gap: 12px; }
.stat-card { flex: 1; padding: 16px; border: 1px solid var(--border-color); border-radius: 8px; text-align: center; }
.stat-num { display: block; font-size: 1.5rem; font-weight: 700; }
.stat-label { font-size: 0.75rem; color: var(--text-tertiary); }
.chart-box { border: 1px solid var(--border-color); border-radius: 8px; padding: 16px; background: var(--bg-primary); }
.chart-box h3 { font-size: 0.85rem; font-weight: 600; }
.chart-box canvas { max-height: 200px; }
.admin-list { border: 1px solid var(--border-color); border-radius: 8px; overflow: hidden; }
.admin-list-item { display: flex; align-items: center; gap: 8px; padding: 8px 12px; border-bottom: 1px solid var(--border-light); font-size: 0.75rem; overflow: hidden; }
.admin-list-item:last-child { border-bottom: none; }
.empty-state { padding: 80px 0; text-align: center; }
</style>
